var SmsTrial = function() {
    return {
        phoneSubmit: function(phone) {
            $('#submit_phonenumber_btn').prop('disabled', true);
            $('#phone_response').html('<i class="icon icon--spinner fal fa-spinner fa-spin"></i>');
            $('#phone_wrapper').removeClass('error');
            Ajax.getVerificationCode(phone, function(res) {
                $('#phone_response').html('').removeClass('error');
                if (res == undefined || res['success'] == undefined ||
                    res['success'] != 'ok') {
                    $('#phone_response').html('Προσπαθήστε ξανά');
                    $('#phone_wrapper').addClass('error');
                    $('#phone_response').show();
                    $('#submit_phonenumber_btn').prop('disabled', false);
                    return;
                }
                if (res['status'] == 'invalid') {
                    $('#phone_wrapper').addClass('error');
                    $('#phone_response').html('Ο αριθμός τηλεφώνου δεν είναι έγκυρος');
                } else if (res['status'] == 'ok') {
                    $('#phone_response').html(
                        'Αν δεν έχεις χρησιμοποιήσει τη δωρεάν δοκιμή, θα λάβεις με μήνυμα τον κωδικό');
                } else {
                    $('#phone_response').html('');
                }
                $('#phone_response').show();
                $('#submit_phonenumber_btn').prop('disabled', false);
            });
        },
        verCodeSubmit: function(code) {
            $('#submit_smspin_btn').prop('disabled', true);
            $('#sms_trial_response').html('<i class="icon icon--spinner fal fa-spinner fa-spin"></i>');
            $('#code_wrapper').removeClass('error');
            Ajax.checkVerificationCode(code, function(res) {
                $('#sms_trial_response').html('').removeClass('error');
                if (res == undefined || res['success'] == undefined || res['success'] != 'ok') {
                    $('#sms_trial_response').html('Προσπαθήστε ξανά');
                    $('#code_wrapper').addClass('error');
                    $('#sms_trial_response').show();
                    $('#submit_smspin_btn').prop('disabled', false);
                    return;
                }
                if (res['status'] == 'invalid') {
                    $('#code_wrapper').addClass('error');
                    $('#sms_trial_response').html('Ο κωδικός δεν είναι σωστός');
                } else if (res['status'] == 'valid') {
                    Modal.removeQueuedModal('fqueue_premium_modal');
                    $('#sms_trial_modal').modal('hide');
                    $('.queuepos').css('fill', '#2c3339');
                    $('#animation_free_tooltip').remove();
                    State.trialCode = code;
                    Chat.startBlind();
                }
                $('#submit_smspin_btn').prop('disabled', false);
            });
        },
        initForm: function() {
            $('#phone_response').html('').removeClass('error');
            $('#sms_trial_response').html('').removeClass('error');
            $('#phone_wrapper').removeClass('error');
            $('#code_wrapper').removeClass('error');
            $('#phonenumber').val('');
            $('#smspin').val('');
            $('#sms_trial_modal').modal('show');

            $('#submit_phonenumber_btn').click(function() {
                SmsTrial.phoneSubmit($('#phonenumber').val());
            });
            $('#submit_smspin_btn').click(function() {
                SmsTrial.verCodeSubmit($('#smspin').val());
            });
        },
        init: function() {
            var onClick = function() {
                Modal.showModal('sms_trial_modal', false, function() {
                    SmsTrial.initForm();
                });
            };
            $('body').on('click', '#trial_modal_show_btn', onClick);
        }
    };
}();
